import { Row, Col } from 'react-bootstrap'
import { CloudIcon, CartIcon, HandshakeIcon, MegaphoneIcon, TruckIcon, BriefcaseIcon } from './Icons'

const Industries = () => {
    const industries = [
        {
            icon: <CloudIcon size={44} />,
            title: "SaaS Companies",
            description: "Custom features, integrations, and AI-powered enhancements for software-as-a-service platforms."
        },
        {
            icon: <CartIcon size={44} />,
            title: "E-commerce Brands",
            description: "Automation tools, inventory systems, and customer service AI for online retailers."
        },
        {
            icon: <HandshakeIcon size={44} />,
            title: "Online Service Providers",
            description: "Booking systems, client portals, and workflow automation for service businesses."
        },
        {
            icon: <MegaphoneIcon size={44} />,
            title: "Marketing Agencies",
            description: "CRM automation, reporting dashboards, and AI content tools for agencies."
        },
        {
            icon: <TruckIcon size={44} />,
            title: "Logistics & Operations",
            description: "Data dashboards, tracking systems, and process automation for operations teams."
        },
        {
            icon: <BriefcaseIcon size={44} />,
            title: "Professional Services",
            description: "Client management tools, document automation, and custom business applications."
        }
    ]

    return (
        <Row className="industries mx-0" id="industries">
            <Row className="mx-0">
                <div className="sectionTitle reveal">
                    Industries We Serve
                </div>
            </Row>
            <Row className="mx-0">
                <div className="sectionDescription reveal">
                    We work with businesses across various sectors to deliver tailored technology solutions.
                </div>
            </Row>
            <Row className="industriesGrid mx-0 justify-content-center">
                {industries.map((industry, index) => (
                    <Col key={index} className="industryCard col-12 col-md-6 col-lg-4 reveal">
                        <div className="industryCardInner">
                            <div className="industryIcon">{industry.icon}</div>
                            <h3 className="industryTitle">{industry.title}</h3>
                            <p className="industryDescription">{industry.description}</p>
                        </div>
                    </Col>
                ))}
            </Row>
        </Row>
    )
}

export default Industries
